export default [
  {
    path: 'experiencias',
    name: 'experiences',
    component: () => import(/* webpackChunkName: "experiences" */ './Index.vue'),
    meta: {
      title: 'Experiências',
      icon: 'mdi-gift',
      admin: true
    }
  },
  {
    path: 'experiencias/:id',
    name: 'experiences.view',
    component: () => import(/* webpackChunkName: "experiences" */ './View.vue'),
    meta: {
      title: 'Experiência',
      icon: 'mdi-gift',
      admin: true
    }
  }
];
